import { render, staticRenderFns } from "./radio_boolean_field.vue?vue&type=template&id=c9473022&lang=pug&"
import script from "./radio_boolean_field.vue?vue&type=script&lang=js&"
export * from "./radio_boolean_field.vue?vue&type=script&lang=js&"
import style0 from "./radio_boolean_field.vue?vue&type=style&index=0&id=c9473022&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports